<style lang="css">
@import '../assets/styles/mainplugin.css';
</style>
<template> 
<b-modal  :static="true" :lazy="true" hide-footer hide-header body-class="p-0" size="xl" v-model="showSearchModal" class="overlay" ref="clsearchmodal">
    <b-container fluid>
         
    <div class="small">
       <SearchBox v-model="searchTerm" @resetSearch="resetSearch" @clearSearchTerm="clearSearch" @searchWithTerm="searchWithTerm" @close="close" @refreshSearch="refreshSearch"/>
    </div>
   
       <SearchList ref="searchview" :clresults="resultsData" :facetSelection="facetSelection" :pages="pages" :pageItems="pageItems" :loading="loading" :filters="filters" :onlyTabResult="onlyTab" @page-change="recalc" 
       @filterClear="clearFilter" @filterUpdate="updateFilters" 
        @openView="showView"/>
         </b-container>
   
  </b-modal>
</template>

<script>
import SearchList from './SearchList'
import SearchBox from './SearchBox'
import SearchPlugin from '../index'


const axios = require('axios');
 
export default {
  components: { SearchList, SearchBox },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    term: {
      type: String,
      default: ''
    },
    resulttype:{
      type: String,
      default:'Recipe'
    },
    token:{
      type: String,
      default: null
    }
  },
  data: () => ({
    showSearchModal: false,
    searchTerm: '',
    results: [],
    resultsData: {recipe:{},ingredients:{},organisations:{}},
    filters: {recipe:[],ingredients:[],organisation:[]},
    facetSelection:[],
    pages: [1,1,1],
    pageItems:4,
    filterParent:'',
    loading:false,
    onlyTab: '',
    dtypes:['Recipes','Ingredients','Organisations']
  }),
  beforeMount () {
     SearchPlugin.event.$on('toggleSearch', this.handleToggleEvent);
     SearchPlugin.event.$on('searchNow', this.handleSearch);
  },
  mounted(){
     var self=this;

     this.loading=true;
     let sTerm=this.$props.term;
     this.onlyTab=this.$props.resulttype;
     if(this.$props.token){
       axios.defaults.headers.common = {'Authorization': `bearer ${token}`}
     }
     this.getAllFilters();
     this.showAll();  
  },
    methods: {
      showAll: function(){
          
          let query={
              "query": '',
              "start": 0,
              "count": this.pageItems,
              "facetsOnly":false,
              "filters":this.facetSelection
            };
          axios.post("search?",query,{withCredentials: true}).then(response => {
            this.resultsData.recipe = response.data.Recipe;
            this.resultsData.ingredients = response.data.Resource;
            this.resultsData.organisations = response.data.Organisation;
           
            this.loading=false;
          })
          if(this.$refs.searchview){
              this.onlyTab=null;
              this.$refs.searchview.resetTabs();
            }
      },
      getAllFilters: function(){
          let query={
              "query": '',
              "start": 0,
              "count": this.pageItems,
              "facetsOnly":true,
              "filters":[]
            };
          axios.post("/search?",query,{withCredentials: true}).then(response => {
            this.resultsData.recipe = [];
            this.resultsData.ingredients = [];
            this.resultsData.organisations = [];
            var keys=Object.keys(response.data.Recipe.facets)
            for(let i=0;i<keys.length;i++) {
                let val=response.data.Recipe.facets[keys[i]];
                val.filtertype=keys[i];
                val.filterparent="Recipe";
                this.filters.recipe.push(val);
                
              }
            keys=Object.keys(response.data.Resource.facets)
            for(let i=0;i<keys.length;i++) {
                let val=response.data.Resource.facets[keys[i]];
                val.filtertype=keys[i];
                val.filterparent="Resource";
                this.filters.ingredients.push(val);
              }
            keys=Object.keys(response.data.Organisation.facets)
            for(let i=0;i<keys.length;i++) {
                let val=response.data.Organisation.facets[keys[i]];
                val.filtertype=keys[i];
                val.filterparent="Organisation";
                this.filters.organisation.push(val);
              }
          
            this.loading=false;
          })
      },
      handleToggleEvent: function(event){
        this.showSearchModal=!this.showSearchModal;
        
      },
      reset: function(){
          this.loading=false;
          this.pages = [1,1,1];
          this.searchTerm='';
          this.page=1;
          this.onlyTab=null;
          this.resulttype=null;
         
          this.resultsData= {recipe:{},ingredients:{},organisations:{}};
          
          this.facetSelection=[];
          this.filters={recipe:[],ingredients:[],organisation:[]};
          
      },
      handleSearch: function(params){
       
        this.reset();
        
        this.loading=true;
        if(params.token){
          axios.defaults.headers.common = {'Authorization': `bearer ${params.token}`}
        }
        this.getAllFilters();
        if(params.resulttype){
          this.onlyTab=params.resulttype;
        }
        else{
          this.onlyTab=null;
        }
        if(this.$refs.searchview){
          this.$refs.searchview.onyTabResult=this.onlyTab;
          this.$refs.searchview.refresh();
        }
       
     
        if(params.term){
         this.searchTerm=params.term;
         
         this.searchWithTerm();    

        }else{
          this.searchTerm='';
          this.showAll();
          
        }
        this.showSearchModal=true;
           
        
      },
      recalc: function(event){
        var index= event.detail.pagetype==='Recipe' ? 1: 2;
        if(event.detail.pagetype==='Organisation') {index=3;}
        this.pages.splice(index-1,1,event.detail.page);
        this.searchPage(event.detail.pagetype);
     },
     close () {
      this.showSearchModal=false; 
      this.$root.$emit('termupdated', this.searchTerm);
    },
    showView: function(event){
      this.close();
      setTimeout(function () {
        this.$root.$emit('showView',event);
      }.bind(this), 10);
       
    },
     searchWithTerm: function(){
        const searchTerm = this.searchTerm.toLowerCase()
        var self = this;
       
        let query={
          "query":searchTerm,
          "start": 0,
          "count": this.pageItems,
          "facetsOnly":false,
          "filters":this.facetSelection
        };
        axios.post("/search?",query,{withCredentials: true}).then(response => {
            self.resultsData.recipe = response.data.Recipe;
            self.resultsData.ingredients = response.data.Resource;
            self.resultsData.organisations = response.data.Organisation;
            /* read new filters */
            var keys=Object.keys(response.data.Recipe.facets)
            if(keys && keys.length>0){
              self.filters.recipe=[];
            
            for(let i=0;i<keys.length;i++) {
                let val=response.data.Recipe.facets[keys[i]];
                val.filtertype=keys[i];
                val.filterparent="Recipe";
                self.filters.recipe.push(val);
                
              }
            }
            keys=Object.keys(response.data.Resource.facets)
            if(keys && keys.length>0){
              self.filters.ingredients=[];
            
            for(let i=0;i<keys.length;i++) {
                let val=response.data.Resource.facets[keys[i]];
                val.filtertype=keys[i];
                val.filterparent="Resource";
                self.filters.ingredients.push(val);
              }
            }
            
            keys=Object.keys(response.data.Organisation.facets)
            if(keys && keys.length>0){
              self.filters.organisation=[];
            for(let i=0;i<keys.length;i++) {
                let val=response.data.Organisation.facets[keys[i]];
                val.filtertype=keys[i];
                val.filterparent="Organisation";
                self.filters.organisation.push(val);
              }
            }
            /*done*/
           
            self.loading=false;
       
            self.pages = [1,1,1];
        
      })   
    },
    searchAgain: function(){
        const searchTerm = this.searchTerm.toLowerCase()
        var self = this;
        var index= this.filterParent==='Recipe' ? 1: 2;
        
        if(this.filterParent==='Organisation') {index=3;}  
        let query={
          "query":searchTerm,
          "start": 0,
          "type":this.filterParent,
          "count": this.pageItems,
          "facetsOnly":false,
          "filters":this.facetSelection
        };
        axios.post("/search?",query,{withCredentials: true}).then(response => {
         if(response.data.Recipe){
            self.resultsData.recipe = response.data.Recipe;
            var keys=Object.keys(response.data.Recipe.facets)
            if(keys && keys.length>0){
              self.filters.recipe=[];
            
            for(let i=0;i<keys.length;i++) {
                let val=response.data.Recipe.facets[keys[i]];
                val.filtertype=keys[i];
                val.filterparent="Recipe";
                self.filters.recipe.push(val);
                
              }
            }
         }
         if(response.data.Resource){
            self.resultsData.ingredients = response.data.Resource;
            keys=Object.keys(response.data.Resource.facets)
            if(keys && keys.length>0){
                self.filters.ingredients=[];
            for(let i=0;i<keys.length;i++) {
                let val=response.data.Resource.facets[keys[i]];
                val.filtertype=keys[i];
                val.filterparent="Resource";
                self.filters.ingredients.push(val);
              }
            }
         }
         if(response.data.Organisation){
            self.resultsData.organisations = response.data.Organisation;
            keys=Object.keys(response.data.Organisation.facets);
            if(keys && keys.length>0){
            self.filters.organisation=[];
                
            for(let i=0;i<keys.length;i++) {
                let val=response.data.Organisation.facets[keys[i]];
                val.filtertype=keys[i];
                val.filterparent="Organisation";
                this.filters.organisation.push(val);
              }
            }
         }
       
        self.pages.splice(index-1,1,1);
        self.loading=false;
      })
      
    },
    searchPage: function(pagetype){
        const searchTerm = this.searchTerm.toLowerCase()
        var self = this;
        var index= pagetype==='Recipe' ? 1: 2;
        if(pagetype==='Organisation') {index=3;}  
        
        let query={
          "query":searchTerm,
          "start": this.pages[index-1]*this.pageItems-this.pageItems,
          "type": pagetype,
          "count": this.pageItems,
          "facetsOnly":false,
          "filters":this.facetSelection
        };
        axios.post('/search?',query,{withCredentials: true}).then(response => {
         if(pagetype==='Recipe'){
            self.resultsData.recipe = response.data.Recipe;
         }
         else if(pagetype==='Resource'){
            self.resultsData.ingredients = response.data.Resource;
         }
         else if(pagetype==='Organisation'){
            self.resultsData.organisations = response.data.Organisation;
         }
       
        self.loading=false;
      })
      
    },
    clearSearch: function(){
        this.searchTerm='';
        this.searchWithTerm();
    },
    resetSearch: function(){
        //this.reset();
        //this.getAllFilters();
        //this.showAll();
        //this.searchWithTerm();
        if(this.$refs.searchview){
              this.onlyTab=null;
              this.$refs.searchview.resetTabs();
        }
    },
    refreshSearch: function(){
        this.reset();
        this.getAllFilters();
        this.showAll();
        this.searchWithTerm();
        if(this.$refs.searchview){
              this.onlyTab=null;
              this.$refs.searchview.resetTabs();
        }
    },
   updateFilters: function(event){
          this.loading=true;
          let facet={"field": event.detail.filtertype, "terms":event.detail.newvalue, "type":event.detail.filterparent};
          this.filterParent=event.detail.filterparent;
          let found= this.facetSelection.some(item => (item.field === event.detail.filtertype && item.type===event.detail.filterparent));
          if(found){
             if(event.detail.newvalue.length==0){
               var newfacets= this.facetSelection.filter(obj => !(obj.field===facet.field && obj.type===facet.type));
               this.facetSelection=newfacets.slice();
             
             }
             else{
             //replace the filter with new value, search again
              this.facetSelection.map(function(obj) {
                (obj.field === facet.field && obj.type===facet.type) && (obj.terms = facet.terms);
              });
             }
             
         }
          else{
              this.facetSelection.push(facet);
          }
          this.searchAgain();
         
    },
     clearFilter: function(event){
         
          this.loading=true;
          let facet={"field": event.detail.filtertype, "type":event.detail.filterparent};
          this.filterParent=event.detail.filterparent;
          var cfacets= this.facetSelection.filter(obj => !(obj.field===facet.field));
          this.facetSelection=cfacets.slice();
          
          this.searchAgain();
          
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  

  .searchcontainer {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
  
  }
  
  .header {
    margin: 10px 0 20px;
  }

  .overlay {
    box-sizing: border-box;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
   
  }

  
  .modal:nth-of-type(even) {
    z-index: 1052 !important;
}
.modal-backdrop.show:nth-of-type(even) {
    z-index: 1051 !important;
}

.container-fluid{
  padding:0 !important;
}
  
</style>
 



// WEBPACK FOOTER //
// src/plugins/SearchPlugin/components/ModalSearch.vue